// Deployed dev environment: platform.{env}.content-dev.castlabs.com
// The env name is derived from the second hostname segment at runtime.
import { PLAYER_LICENSE } from './player-license';

const _devEnv = window.location.hostname.split('.')[1] ?? 'dev';

export const environment = {
  production: false,
  localDev: false,
  env_name: _devEnv,
  accountId: '561405691527',

  castlabs_idp_issuer: 'https://oauth-proxy.content-dev.castlabs.com',
  castlabs_idp_app_client_id: '2o4rt792ffknurp5qb5uv46s3h',
  castlabs_idp_logout_url: 'https://oauth-proxy.content-dev.castlabs.com/logout',
  castlabs_idp_api_base: 'https://auth.test.cs.castlabs.com/api/v1',
  castlabs_idp_mfa_setup: 'https://account.test.cs.castlabs.com/account',

  above_idp_issuer: 'https://cognito-idp.us-east-1.amazonaws.com/us-east-1_NdTjueRpE',
  above_idp_app_client_id: '3tu1fdceo0dff13umce21f9ab9',

  uploaderurl: `https://up.${_devEnv}.content-dev.castlabs.com`,

  VTK: 'https://fe.vtks.castlabs.com',
  VTK_API: 'https://api.vtks.castlabs.com',
  Portal: `https://portal.${_devEnv}.content-dev.castlabs.com`,

  region: 'us-east-1',
  graphql: `https://repository.${_devEnv}.content-dev.castlabs.com/graphql`,
  workflow_graphql: `https://workflow.${_devEnv}.content-dev.castlabs.com/graphql`,
  status_graphql: `https://status.${_devEnv}.content-dev.castlabs.com/graphql`,
  signiant_graphql: `https://rx-signiant.${_devEnv}.content-dev.castlabs.com/graphql`,
  crd_signal_server: `https://crd-signal.${_devEnv}.content-dev.castlabs.com`,

  // Shared across all environments -- see ./player-license.ts
  player_license: PLAYER_LICENSE,

  title: `Castlabs Content Platform (${_devEnv})`,


  // DynamoDB table name has a random CloudFormation suffix — not derivable at build time.
  poitems_table: '',

  redirects: {
    'above_above': 'urn:janus:organization:0a46318f20c445a19f9ecc7853f86d90',
    'above_touch': 'urn:janus:organization:3b74f8613e8c4169a933f3047f3351de',
    'castlabs': 'urn:janus:organization:9fa73f786f62470c838995d019f2c393'
  }
};
